import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MapPopupComponent } from 'src/app/modules/current-voyages/pages/map-popup/map-popup.component';
import { ToasterMessages } from '../../constants/constants';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vessel-status-popup',
  templateUrl: './vessel-status-popup.component.html',
  styleUrls: ['./vessel-status-popup.component.scss']
})
export class VesselStatusPopupComponent {
  statusOptions = ['Active', 'Inactive']; 
  reasonOptions:any;
  selectedStatus: string | null = null;
  selectedReason: string | null = null;
  snackBar: any;
  constructor(private dialogRef: MatDialogRef<MapPopupComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
  private toastr: ToastrService,
) {
    this.reasonOptions = data?.reasonOptions
      ? ['Drydock', 'Redelivered']
      : ['Delivered back to charterer'];
  }
  submitDateTime(confirmed: boolean): void {

    if (confirmed && this.selectedStatus !== null && this.selectedReason !== null) {
      const statusBoolean = this.selectedStatus === 'Active' ? true : false;
      const result = {
        status: statusBoolean,
        reason: this.selectedReason
      };
      this.dialogRef.close(result);
    } else if (!confirmed){
      this.dialogRef.close();
    
      
    }
    else{
      this.toastr.info(ToasterMessages.FormValidation); 
    }
     
  }
  
  cancel(): void {
    this.dialogRef.close();
  }
 
}
